.m-iconbtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--m-space-3);
  flex: none;

  /* a square; only a count badge widens it */
  height: var(--m-control-height-sm);
  width: var(--m-control-height-sm);
  border: 1px solid transparent;
  border-radius: var(--m-radius-control);
  color: var(--m-content-secondary);
  transition:
    border-color var(--m-duration-fast) var(--m-ease-out),
    background-color var(--m-duration-fast) var(--m-ease-out),
    color var(--m-duration-fast) var(--m-ease-out);
}

.m-iconbtn:has(.m-iconbtn__count) {
  width: auto;
  min-width: var(--m-control-height-sm);
  padding-inline: var(--m-space-4);
}

/* embedded in a field or a value row, where `sm` would touch its edge */
.m-iconbtn--xs {
  height: var(--m-control-height-xs);
  width: var(--m-control-height-xs);
}
.m-iconbtn--xs:has(.m-iconbtn__count) {
  min-width: var(--m-control-height-xs);
}

.m-iconbtn--outline {
  border-color: var(--m-border-default);
  background: var(--m-surface-default);
}
.m-iconbtn--outline:hover {
  border-color: var(--m-border-strong);
  color: var(--m-content-primary);
}

.m-iconbtn--ghost {
  background: transparent;
  color: var(--m-content-muted);
}
.m-iconbtn--ghost:hover {
  background: var(--m-surface-hover);
  color: var(--m-content-primary);
}

.m-iconbtn.is-open {
  background: var(--m-surface-hover);
  color: var(--m-content-primary);
}
.m-iconbtn.is-active {
  color: var(--m-content-primary);
}

.m-iconbtn:disabled {
  color: var(--m-content-disabled);
  cursor: default;
}
.m-iconbtn:disabled:hover {
  background: transparent;
  color: var(--m-content-disabled);
}

.m-iconbtn {
  position: relative;
}
.m-iconbtn::after {
  content: '';
  position: absolute;
  inset: -9px;
}

.m-iconbtn__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
}

.m-iconbtn__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding-inline: 4px;
  border: 1px solid var(--m-pill-on-border);
  border-radius: var(--m-radius-chip);
  background: var(--m-pill-on-bg);
  color: var(--m-pill-on-fg);
  font-size: var(--m-text-2xs);
  font-weight: var(--m-weight-medium);
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.m-iconbtn.is-on {
  background: var(--m-surface-selected);
  border-color: var(--m-border-accent);
  color: var(--m-content-accent);
}
.m-iconbtn--ghost.is-on:hover {
  background: var(--m-surface-selected);
}

.m-iconbtn--primary {
  background: var(--m-action-primary-bg);
  border-color: var(--m-action-primary-bg);
  color: var(--m-action-primary-fg);
}
.m-iconbtn--primary:hover {
  background: var(--m-action-primary-bg-hover);
  border-color: var(--m-action-primary-bg-hover);
  color: var(--m-action-primary-fg);
}
.m-iconbtn--primary:active {
  background: var(--m-action-primary-bg-active);
  border-color: var(--m-action-primary-bg-active);
}
